'use strict';

import angular from 'angular';
import ConfirmController from './confirm.controller';

export default angular.module('updateServerApp.devices.confirm', [])
  .controller('DevicesConfirmController', ConfirmController)
  .name;



// WEBPACK FOOTER //
// ./client/app/devices/confirm/index.js